import React, { useState } from 'react';
import './SharesLoan.css';
import LoanAgainstSharesBanner from '../images/loan-against-shares.jpg';
import LoanAgainstSharesPNG from '../images/loan-against-shares1.png';

const SharesLoan = () => {
  const [activeTab, setActiveTab] = useState('eligibility');
  const [activeSubTab, setActiveSubTab] = useState('individual');

  return (
    <div className="shares-loan-page" style={{ backgroundImage: `url(${LoanAgainstSharesBanner})` }}>
      {/* Banner Section */}
      <section className="shares-loan-banner">
        <div className="shares-banner-container">
          <div className="shares-banner-left">
            <div className="shares-banner-image" style={{ backgroundImage: `url(${LoanAgainstSharesBanner})` }}>
              <div className="shares-image-overlay">
                <h1 className="shares-banner-title">LOAN AGAINST SHARES</h1>
              </div>
            </div>
          </div>
          <div className="shares-banner-right">
            <div className="shares-banner-content">
              <h2 className="shares-banner-subtitle">WE OFFER A FULL RANGE OF LOAN AGAINST SHARES SERVICES</h2>
              <p className="shares-banner-description">
                A loan against shares (LAS) is a secured loan where individuals mortgage their shares as collaterals to raise funds. In this type of loan, people can obtain financial support without having to sell off their shares. Competitive rates, flexible repayment options makes loan against shares a feasible solution for business financing.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features/Benefits Section */}
      <section className="shares-features-section">
        <div className="shares-features-container">
          <h2 className="shares-features-heading">FEATURES/BENEFITS</h2>
          <div className="shares-features-content">
            <div className="shares-features-image-wrapper">
              <img src={LoanAgainstSharesPNG} alt="Loan Against Shares Features" className="shares-features-image" />
            </div>
            <div className="shares-features-list">
              <div className="shares-feature-item">
                <h3 className="shares-feature-title">LOAN TENURE</h3>
                <p className="shares-feature-description">Avail a flexible loan tenure of up to 3 years, giving you ample time to manage your repayments comfortably while keeping your investment portfolio intact.</p>
              </div>
              <div className="shares-feature-item">
                <h3 className="shares-feature-title">MAXIMUM LOAN AMOUNT</h3>
                <p className="shares-feature-description">Avail loans in the range of Rs. 1 Lakh to Rs. 10 Lakh based on the value of your shares, providing you with substantial liquidity without selling your investments.</p>
              </div>
              <div className="shares-feature-item">
                <h3 className="shares-feature-title">FAST & HASSLE-FREE PROCESSING</h3>
                <p className="shares-feature-description">Receive funds within 72 hours* with our well-organized approval process. Minimal documentation and quick verification ensure you get the funds when you need them most.</p>
              </div>
              <div className="shares-feature-item">
                <h3 className="shares-feature-title">COMPETITIVE INTEREST RATES</h3>
                <p className="shares-feature-description">Get Loan against Shares at attractive interest rates starting from just 12%*. Benefit from our EMIs and part prepayment scheme for more control over your finances and reduced interest burden.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eligibility and Documents Section */}
      <section className="shares-eligibility-section">
        <div className="shares-eligibility-container">
          <div className="shares-tabs">
            <button 
              className={`shares-tab ${activeTab === 'eligibility' ? 'active' : ''}`}
              onClick={() => setActiveTab('eligibility')}
            >
              Eligibility Criteria
            </button>
            <button 
              className={`shares-tab ${activeTab === 'documents' ? 'active' : ''}`}
              onClick={() => setActiveTab('documents')}
            >
              Required Documents
            </button>
          </div>

          {activeTab === 'eligibility' && (
            <div className="shares-tab-content">
              <div className="shares-eligibility-grid">
                <div className="shares-eligibility-card">
                  <h3 className="shares-eligibility-title">SALARIED INDIVIDUALS</h3>
                  <p className="shares-eligibility-text">
                    Must be a resident of India having age between 21-55 years. They should be employed with a public, private or a multinational organization.
                  </p>
                </div>
                <div className="shares-eligibility-card">
                  <h3 className="shares-eligibility-title">SELF-EMPLOYED INDIVIDUALS</h3>
                  <p className="shares-eligibility-text">
                    Must be a resident of India having age between 21-55 years. They should be a business person with a stable business income.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'documents' && (
            <div className="shares-tab-content">
              <div className="shares-sub-tabs">
                <button 
                  className={`shares-sub-tab ${activeSubTab === 'individual' ? 'active' : ''}`}
                  onClick={() => setActiveSubTab('individual')}
                >
                  For Salaried Individuals
                </button>
                <button 
                  className={`shares-sub-tab ${activeSubTab === 'businessman' ? 'active' : ''}`}
                  onClick={() => setActiveSubTab('businessman')}
                >
                  For Businessmen
                </button>
              </div>

              {activeSubTab === 'individual' && (
                <div className="shares-documents-grid">
                  <div className="shares-documents-card">
                    <h3 className="shares-documents-title">AGE PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                    <ul className="shares-documents-list">
                      <li>PAN Card</li>
                      <li>Aadhar Card</li>
                      <li>ITR or Financial Statements</li>
                      <li>Property documents for mortgage</li>
                      <li>Property title documents</li>
                    </ul>
                  </div>
                  <div className="shares-documents-card">
                    <h3 className="shares-documents-title">ADDRESS PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                    <ul className="shares-documents-list">
                      <li>Latest salary slips (For salaried individuals)</li>
                      <li>Bank account statements for the last 3 months (For Salaried Individuals). 6 months (For Self Employed Professionals)</li>
                      <li>PAN card or Form 60 (for all applicants)</li>
                      <li>Valid ID proof</li>
                      <li>Address proof</li>
                      <li>Property documents for mortgage</li>
                      <li>Income Tax returns</li>
                      <li>Property title documents</li>
                    </ul>
                  </div>
                  <div className="shares-documents-card">
                    <h3 className="shares-documents-title">INCOME PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                    <ul className="shares-documents-list">
                      <li>ITR of the latest 2 years along with computation (When borrower is an individual)</li>
                      <li>Audited/ CA certified Profit and Loss Account and Balance Sheet (When borrower is a company/ firm)</li>
                      <li>Bank account statements for the last 1 year (Savings and Current Account)</li>
                    </ul>
                  </div>
                </div>
              )}

              {activeSubTab === 'businessman' && (
                <div className="shares-documents-grid">
                  <div className="shares-documents-card">
                    <h3 className="shares-documents-title">AGE PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                    <ul className="shares-documents-list">
                      <li>PAN Card</li>
                      <li>Aadhar Card</li>
                      <li>ITR or Financial Statements</li>
                      <li>Property documents for mortgage</li>
                      <li>Property title documents</li>
                    </ul>
                  </div>
                  <div className="shares-documents-card">
                    <h3 className="shares-documents-title">ADDRESS PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                    <ul className="shares-documents-list">
                      <li>Passport</li>
                      <li>Election ID Card</li>
                      <li>Utility Bill</li>
                      <li>Driving License</li>
                      <li>Registered Rent Agreement</li>
                      <li>Aadhar Card</li>
                    </ul>
                  </div>
                  <div className="shares-documents-card">
                    <h3 className="shares-documents-title">INCOME PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                    <ul className="shares-documents-list">
                      <li>ITR of the latest 2 years along with computation (When borrower is an individual)</li>
                      <li>Audited/ CA certified Profit and Loss Account and Balance Sheet (When borrower is a company/ firm)</li>
                      <li>Bank account statements for the last 1 year (Savings and Current Account)</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      {/* Learn More Section */}
      <section className="shares-learn-more-section">
        <div className="shares-learn-more-container">
          <div className="shares-learn-more-content">
            <h2 className="shares-learn-more-title">Learn More About Our Services</h2>
            <p className="shares-learn-more-text">Reach out to us for inquiries.</p>
          </div>
          <a href="/contact" className="shares-contact-btn">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default SharesLoan;

